import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { PivotControl } from "../../constants/pivot_control_options";
import { defaultConfig } from "./default_config";
import { paramsToTransformArgs } from "./params_to_transform_args";
import { createInventoryHealthMRPMatrix } from "./createInventoryHealthMRPMatrix";
import { DatePivotParams } from "../../entities/date_pivot_params";

export const InventoryHealthContainer = () => {
  // Customer-specific date hierarchy configurations
  const dateHierarchyColumnFilter = {
    week: "week",
    month: "month",
    day: "day",
  };

  // Measures available for aggregation (excluding demand measures)
  const measureColumnFilter = (params: DatePivotParams) => {
    return {
      "starting inventory": "starting inventory",
      "purchase order arrival": "purchase order arrival",
      "ending inventory": "ending inventory",
      "purchase order to place": "purchase order to place",
      scrap: "scrap",
    };
  };

  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "supply_walk_test_component",
        transformId: "supply_walk_mrp_parallelized",
        folder: "outputs",
        title: "Inventory Health - MRP",
        dateHierarchyColumnFilter,
        excludedSegmentationsFilter: [],
        measureColumnFilter,
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.DateHierarchy,
          PivotControl.FilterBy,
          PivotControl.DatePeriodPicker,
          PivotControl.Measure,
          PivotControl.ShowSettings,
          PivotControl.StoreAsDefault,
          PivotControl.Download,
        ],
        paramsToTransformArgs,
        getMatrix: createInventoryHealthMRPMatrix,
      }}
      defaultConfig={defaultConfig}
    />
  );
};
